module.exports = __webpack_public_path__ + "img/robot.625c9248.png";